import { createSystemRoutes } from "../routing";
import type { SettingsStore } from "../stores/settings";
import type { TurnstileTokenData } from "../stores/session";
import { isDemoMode } from "../stores/mode";

type ShowCaptchaProps = {
  route: string;
  settings?: SettingsStore;
  turnstileTokenData?: TurnstileTokenData;
};

export const showCaptcha = ({
  route,
  settings,
  turnstileTokenData
}: ShowCaptchaProps) => {
  if (isDemoMode()) { // editor mode is also demo mode
    return false;
  }

  const hasConfig = Boolean(settings?.campaign);
  const requiresCaptcha = Boolean(settings?.requiresCaptcha);
  const isProcessComplete = Boolean(turnstileTokenData?.hasCompletedCaptchaProcess);

  const retryAt = turnstileTokenData?.retryAt;
  const isRateLimited = retryAt ? new Date(retryAt).getTime() > Date.now() : false;

  // don't show captcha on system route pages
  const isCaptchaFreePage = createSystemRoutes(settings ?? {}).map((route) => route.path).includes(route);
  return !isCaptchaFreePage && !isProcessComplete && !isRateLimited && hasConfig && requiresCaptcha;
};
